<div class="w-80 min-h-[485px] flex flex-col rounded-md">
  <div class="flex flex-col grow">
    <div class="flex justify-center items-center">
      <div class="flex flex-col items-center">
        <img class="h-[100px]" src="assets/images/gopher_buddy_logo.png" alt="Gopher Buddy Logo" />
      </div>
    </div>

    <div class="!flex flex-col grow" *ngIf="appState$ | async as appStateData">
      <mat-drawer-container class="!flex flex-col grow">
        <mat-drawer class="w-[300px] p-2" #helpDrawer mode="over" position="end">
          <app-gb-help></app-gb-help>
        </mat-drawer>
        <mat-drawer-content class="!flex flex-col grow">
          <mat-tab-group class="!flex flex-col grow">
            <mat-tab label="Chrome update info">
              <ng-template mat-tab-label>
                <mat-icon>system_update_alt</mat-icon>
              </ng-template>
              <ng-container
                *ngIf="hasErrors(appStateData)"
                [ngTemplateOutlet]="ErrorPanel"
                [ngTemplateOutletContext]="{ appStateData }"
              ></ng-container>

              <ng-container
                *ngIf="!hasErrors(appStateData)"
                [ngTemplateOutlet]="
                  isLoaded(appStateData)
                    ? isManaged(appStateData)
                      ? isValidCustomer(appStateData)
                        ? ValidCustomerPanel
                        : NotValidCustomerPanel
                      : NotManagedPanel
                    : LoadingPanel
                "
                [ngTemplateOutletContext]="{ appStateData }"
              >
              </ng-container>
            </mat-tab>
            <mat-tab label="Your device info" [disabled]="!isManaged(appStateData)">
              <ng-template mat-tab-label>
                <mat-icon>laptop_chromebook</mat-icon>
              </ng-template>
              <app-gb-deviceinfo></app-gb-deviceinfo>
            </mat-tab>
          </mat-tab-group>
        </mat-drawer-content>
      </mat-drawer-container>
    </div>
    <app-gb-footer></app-gb-footer>
  </div>
</div>

<!-- TEMPLATES ARE ALL BELOW -->
<ng-template #LoadingPanel let-appState="appStateData">
  <div class="flex flex-col justify-center items-center">
    <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-600"></div>
    <span class="font-bold">Checking In</span>
  </div>
</ng-template>

<ng-template #ValidCustomerPanel let-appState="appStateData">
  <div class="flex flex-col flex-justify-center items-center">
    <div *ngIf="!checkVersionEnabled(appState)">
      <p>
        Checking Chrome version<br />
        in Gopher Buddy<br />
        is disabled by your admin
      </p>
    </div>

    <div *ngIf="checkVersionEnabled(appState)">
      <div class="flex flex-col justify-center items-center text-base" *ngIf="versionIsCurrent(appState)">
        <div>Gopher Buddy says</div>
        <div class="font-bold">Chrome is up to date!</div>
        <div>&nbsp;</div>
        <div>Last Checked:</div>
        <div class="font-bold">{{ lastVersionCheck(appState) | date : 'short' }}</div>
      </div>

      <div class="flex flex-col justify-center items-center gap-y-1 text-base" *ngIf="!versionIsCurrent(appState)">
        <div class="font-bold">Chrome needs to update!</div>

        <div class="flex flex-col justify-center items-center">
          <div>Your version:</div>
          <div class="font-bold">{{ appState.app.settings?.deviceDetails?.details.OSVersion }}</div>
        </div>

        <div class="flex flex-col justify-center items-center">
          <div>Newest version:</div>
          <div class="font-bold">{{ appState.app.settings?.deviceDetails.deviceResource?.latestStableVersion }}</div>
        </div>

        <button class="w-full" mat-raised-button color="primary" (click)="onFixVersion()">Fix it</button>
      </div>
    </div>
  </div>

  <div class="flex justify-center items-center gap-x-2">
    <div class="flex justify-center items-center">
      <button mat-raised-button (click)="clearCache()" [disabled]="cacheClearing">Clear cache</button>
    </div>

    <div *ngIf="hasDeviceInfoAccess(appState)" class="flex justify-center items-center">
      <button mat-raised-button (click)="openDeviceDetails()">Device info</button>
    </div>
  </div>
</ng-template>

<ng-template #ErrorPanel let-appState="appStateData">
  <div class="flex flex-col justify-center items-center text-base">
    <div>Error loading Gopher Buddy <strong>:(</strong></div>
    <div>We'll keep trying...</div>
    <div>&nbsp;</div>
    <div>If you continue to see this message,</div>
    <div>contact your school's computer support</div>
    <div>and let them know.</div>
  </div>
</ng-template>

<ng-template #NotManagedPanel let-appState="appStateData">
  <div class="flex flex-col justify-center items-center">
    <div>Gopher Buddy is an admin tool for</div>
    <div>managed Chromebooks on</div>
    <div class="font-bold">{{ appState.app.settings?.userProfile.userProfile.domain }}</div>
    <div>&nbsp;</div>
    <div>It performs no actions on Chrome browsers.</div>
  </div>
</ng-template>

<ng-template #NotValidCustomerPanel let-appState="appStateData">
  <div class="flex flex-col justify-center items-center">
    <div>Gopher Buddy is installed correctly</div>
    <div>on your Chromebook,</div>
    <div>but your school's settings</div>
    <div>may need some help.</div>
    <div>&nbsp;</div>
    <div>If you continue to see this message,</div>
    <div>contact your school's computer support</div>
    <div>and let them know.</div>
  </div>
</ng-template>
